import LuxurySelect from './LuxurySelect';

class Helpers {
    constructor() {
        this.btns = [];
        this.videos = [];
        this.selects = [];
        this.observer = null;
        this.videoObserver = null;
    }

    init() {
        this.destroy();
        this.initBtns();
        this.initLazyVideos();
        this.initSelects();
    }

    initBtns() {
        this.btns = document.querySelectorAll('.btn');
        if (!this.btns.length) return;

        this.observer = new ResizeObserver(entries => {
            requestAnimationFrame(() => {
                entries.forEach(entry => {
                    entry.target.querySelectorAll('.btn').forEach(btn => {
                        this.fitText(btn);
                    });
                });
            });
        });

        this.btns.forEach(btn => {
            const textNode = btn.querySelector('span') || btn;
            textNode.style.fontSize = '';
            btn.dataset.baseSize = window.getComputedStyle(textNode).fontSize;

            const container = btn.parentElement;
            if (container) this.observer.observe(container);
        });

        this.btns.forEach(btn => this.fitText(btn));
    }

    fitText(btn) {
        const textNode = btn.querySelector('span') || btn;
        const baseSize = btn.dataset.baseSize;
        if (!baseSize) return;

        textNode.style.fontSize = baseSize;
        textNode.style.whiteSpace = 'nowrap';
        if (textNode !== btn) {
            textNode.style.display = 'inline-block';
            textNode.style.flexShrink = '0';
        }

        btn.style.width = '100%';
        const maxBtnWidth = btn.getBoundingClientRect().width;
        btn.style.width = maxBtnWidth + 'px';

        const btnStyle = window.getComputedStyle(btn);
        const padding = parseFloat(btnStyle.paddingLeft) + parseFloat(btnStyle.paddingRight);
        const icon = btn.querySelector('svg, i, img, .icon');
        const iconWidth = icon ? icon.getBoundingClientRect().width + 8 : 0;
        const availableWidth = maxBtnWidth - padding - iconWidth;

        const textWidth = textNode.scrollWidth;
        if (textWidth > availableWidth) {
            const fontSize = parseFloat(baseSize);
            const ratio = availableWidth / textWidth;
            textNode.style.fontSize = `${Math.max(fontSize * ratio, 8)}px`;
        }

        btn.style.width = '';
        btn.style.maxWidth = '';
        btn.style.minWidth = '';

        if (textNode !== btn) {
            textNode.style.flexShrink = '';
        }
    }

    initSelects() {
        const selects = document.querySelectorAll('select');
        selects.forEach(select => {
            if (select.style.display === 'none') return;
            this.selects.push(new LuxurySelect(select));
        });
    }

    initLazyVideos() {
        const allVideos = document.querySelectorAll('video');
        const videos = Array.from(allVideos).filter(video =>
            !video.closest('.glide__slide--clone')
        );

        if (!videos.length) return;

        this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const video = entry.target;

              
                const source = video.querySelector('source[data-src]');
                if (source) {
                    source.src = source.dataset.src;
                    delete source.dataset.src;
                    video.load();
                }


                if (video.hasAttribute('data-autoplay')) {
                    video.play().catch(() => { });
                }

                this.videoObserver.unobserve(video);
            });
        }, { threshold: 0.3 });

        this.videos = videos;
        this.videos.forEach(video => {
            video.pause();
            this.videoObserver.observe(video);
        });
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        if (this.videoObserver) {
            this.videoObserver.disconnect();
            this.videoObserver = null;
        }
        this.btns.forEach(btn => {
            const target = btn.querySelector('span') || btn;
            target.style.fontSize = '';
            target.style.whiteSpace = '';
            target.style.display = '';
            delete btn.dataset.baseSize;
        });
        this.btns = [];
        this.selects.forEach(select => {
            if (typeof select.destroy === 'function') select.destroy();
        });
        this.selects = [];
    }
}

export default Helpers;